module.exports = __webpack_public_path__ + "static/media/filter.1cebefc7.svg";